import { render, staticRenderFns } from "./ServiceContactReport.vue?vue&type=template&id=f329d6e2&lang=pug"
import script from "./ServiceContactReport.vue?vue&type=script&lang=js"
export * from "./ServiceContactReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports